//
//
//
//
//
//

export default {
  props: {
    body: String
  }
}
